export default {
    INITIAL: 0,
    I_OFFERED: 1,
    I_AM_OFFERED: 2,
    ACCEPTED: 3, // NOT REVIEWED
    REVIEWED: 4,
}